import React from 'react';
import { useParticipant } from '@daily-co/daily-react-hooks';
import { Box } from '@mui/material';
import { theme } from '../../../../../../common/styles/theme';

const IconMicOff = require('!!@svgr/webpack!../../icons/mic-off-sm.svg').default;
const IconMicOn = require('!!@svgr/webpack!../../icons/mic-on-sm.svg').default;

export const MicStatus: React.FC<{ sessionId: string }> = ({ sessionId }) => {
	const participant = useParticipant(sessionId);
	if (!participant) return null;
	const state = participant.tracks.audio?.state;
	// Mic toggle is a gain mute (track stays playable) — see MediaDeviceProvider.toggleMic.
	const isMuted = state === 'off' || state === 'blocked' ||
		!!(participant.userData as { micMuted?: boolean } | undefined)?.micMuted;
	return (
		<Box
			component={isMuted ? IconMicOff : IconMicOn}
			// svgr strips viewBox, without it a narrower width crops instead of scaling.
			// Must match the viewBox of mic-off-sm.svg / mic-on-sm.svg.
			viewBox={isMuted ? '0 0 16 17' : '0 0 16 16'}
			preserveAspectRatio={'none'}
			sx={{
				flexShrink: 0,
				width: 10,
				height: 14,
				color: theme.palette.common.white,
				opacity: isMuted ? .5 : 1,
			}}
		/>
	);
};
